<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
      <h3 class="text-center">用户名</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <el-form-item prop="username">
          <YueDanIpt model="username" :object="form" placeholder="用户名"></YueDanIpt>
        </el-form-item>
        <p>用户名只可修改一次</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="loading" class="block" type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['user'],
  components: {
    YueDanIpt: YueDanIpt
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
      isEmptyErrors: true,
      errors: null,
      dialogFormVisible: false,
      loading: false,
      form: {},
      rules: {
        username: [
          { required: true, message: '用户名是必填项', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    show () {
      this.isEmptyErrors = true
      this.dialogFormVisible = true
      this.form.username = this.user.username
    },
    async submit () {
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if(this.form.username.indexOf(' ') > -1) {
          this.isEmptyErrors = false
            this.errors = {
              username: [
                {message: ' 用户名不能包含空格'}
              ]
            }
            return
        }
        _.each(['test', 'admin', 'administrator', 'guest', 'joy', 'order'],item => {
          console.log(this.form.username.indexOf(item))
          if(this.form.username.indexOf(item) > -1) {
            this.isEmptyErrors = false
            this.errors = {
              username: [
                {message: ' 用户名不能包含‘'+item+'’'}
              ]
            }
            return false
          }
        })
        if(!this.form.username){
           this.isEmptyErrors = false
            this.errors = {
              username: [
                {message: '用户名是必填项'}
              ]
            }
            return
        }
        if(!this.isEmptyErrors){
          return
        }
        if (valid) {
          let res = await api.post(this, {
            path: 'buyer.php',
            api: 'update_username',
            data: {
              username: this.form.username
            }
          })
          if(res.body.status == 'ok'){
            this.dialogFormVisible = false
            this.user.username = this.form.username
            this.user.username_changed = 1
          }else{
            if(res.body.result == 'username_exist') {
              this.isEmptyErrors = false
              this.errors = {
                username: [
                  {message: '此用户名已存在'}
                ]
              }
              return
            }
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  p {
    color:rgba(136,136,136,1);
    line-height:14px;
    padding-left: 10px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user_center/components/Username.vue